import { selectBasketRentingSummary, selectBasketToPay } from 'containers/OrderDetails/basketSlice'
import { useReduxSelector } from 'store'

export interface ToPayNow {
  list: ToPayNowList[]
  price_sum: string
  price_sum_net: string
  depositAmount?: string
}

interface ToPayNowList {
  type: string
  text: string
  price: string
  price_net: string
  depositAmount?: string
}

export interface DeliveriesPrice {
  grossPrice: string
  netPrice: string
  deliveries: Deliveries
}

type Deliveries = Record<string, DeliveryPrice>
interface DeliveryPrice {
  grossPrice: string
  netPrice: string
}

const useSummaryData = (
  identifier: string
) => {
  const toPay = useReduxSelector(selectBasketToPay)
  const rentingSummary = useReduxSelector(selectBasketRentingSummary)
  if (!identifier || !toPay) return
  return {
    all: toPay,
    now: toPay[identifier]?.to_pay as ToPayNow,
    monthly: toPay[identifier]?.schedule_list_details as warehouse.MonthlyScheduleItem[],
    deliveries: rentingSummary?.deliveryPrice as DeliveriesPrice | undefined
  }
}

export default useSummaryData